/* 头部组件所使用的静态数据 */

// 语言选项
export const languageList = Object.freeze([
  {
    value: 'it',
    text: 'Italiano',
  },
  {
    value: 'pt',
    text: 'Português',
  },
  {
    value: 'es',
    text: 'Español',
  },
  {
    value: 'de',
    text: 'Deutsch',
  },
  {
    value: 'fr',
    text: 'Français',
  },
  {
    value: 'en',
    text: 'English',
  },
]);
